export default __webpack_public_path__ + "static/Profile-ec137466d120c1a12f3ff302727442b3.svg";